import React, { useState, useMemo } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { INITIAL_DUE_DILIGENCE } from '../formQuestionsEnum';
import FormTextField from '../FormFields/FormTextField';
import FieldContainer from '../FormFields/FieldContainer';
import FormTitle from '../FormFields/FormTitle';
import FormAutocomplete from '../FormFields/FormAutocomplete';

PortfolioForm.propTypes = {
  permissions: PropTypes.object,
  isAdmin: PropTypes.bool,
};

export default function PortfolioForm({ permissions, isAdmin }) {
  const [focusedField, setFocusedField] = useState(null);
  const companyOptions = useSelector((state) => state.transitions?.data?.companyOptions);
  const { watch } = useFormContext();

  const companyId = watch(INITIAL_DUE_DILIGENCE.COMPANY.fieldName);

  const fieldIds = [INITIAL_DUE_DILIGENCE.PORTFOLIO_NAME.id, INITIAL_DUE_DILIGENCE.COMPANY.id];

  const showForm = fieldIds.some((id) => id in permissions) || isAdmin;

  const { adminOptions, answerOption } = useMemo(
    () => ({
      adminOptions: companyOptions?.filter((opt) => opt.isAdminOption) ?? [],
      answerOption: companyOptions?.filter((opt) => String(opt.value) === String(companyId)) ?? [],
    }),
    [companyOptions, companyId]
  );

  return (
    showForm && (
      <Grid container spacing={1.5}>
        {(isAdmin || INITIAL_DUE_DILIGENCE.PORTFOLIO_NAME.id in permissions) && (
          <Grid item xs={12} md={6}>
            <FieldContainer>
              <FormTitle fieldAttributes={{ questionTitle: 'Portfolio Name' }} isRequired />
              <FormTextField
                fieldName={INITIAL_DUE_DILIGENCE.PORTFOLIO_NAME.fieldName}
                fieldAttributes={{
                  isEditable: isAdmin,
                  validation: {
                    required: 'Portfolio name is required',
                    pattern: {
                      value: /\S/,
                      message: 'Portfolio name is required',
                    },
                  },
                }}
                focusedField={focusedField}
                setFocusedField={setFocusedField}
              />
            </FieldContainer>
          </Grid>
        )}

        {(isAdmin || INITIAL_DUE_DILIGENCE.COMPANY.id in permissions) && (
          <Grid item xs={12} md={6}>
            <FieldContainer>
              <FormTitle fieldAttributes={{ questionTitle: 'Company' }} isRequired />
              <FormAutocomplete
                fieldName={INITIAL_DUE_DILIGENCE.COMPANY.fieldName}
                fieldAttributes={{
                  isEditable: isAdmin,
                  validation: {
                    required: 'Company is required',
                    pattern: {
                      value: /\S/,
                      message: 'Company is required',
                    },
                  },
                }}
                options={isAdmin ? adminOptions : answerOption}
              />
            </FieldContainer>
          </Grid>
        )}
      </Grid>
    )
  );
}
